import { type AnyAction } from 'redux';
import { LOGOUT } from '../actions/actionTypes/user';
import { SEND_REQUEST_FAIL, SEND_REQUEST_SUCCESS } from '../actions/actionTypes/request';
import { REQUEST_TYPES } from '../../api/requests/requestTypes';
import { sendEvent } from '../../tracker/MatomoAnalytics';
import { selectUserFromToken } from '../../utils/token';
import { REHYDRATION_DONE } from '../actions/actionTypes/common';
import { EVENT_ARGS } from '../../tracker/config';
import { getMockedAppConfig } from '../../utils/mockedAppConfig';
import { type UserState } from '../types';

export const initialState: UserState = {
    id: 0,
    computedUsername: '',
    email: '',
    languageCode: null,
    role: '',
    agencyId: undefined,
    locationId: 0,
    locationIds: [],
    companyId: 0,
    companyName: '',
    appConfig: null,
    teamId: null,
    team: []
};

export const user = (state = initialState, action: AnyAction): UserState => {
    const { type, payload, request = {} } = action;

    switch (type) {
        case SEND_REQUEST_SUCCESS: {
            switch (request.type) {
                case REQUEST_TYPES.LOGIN: {
                    try {
                        const profile = selectUserFromToken(payload.data.token);

                        return {
                            ...state,
                            ...profile
                        };
                    } catch (e) {
                        console.error(e);
                        return { ...initialState };
                    }
                }

                case REQUEST_TYPES.GET_CONFIG: {
                    try {
                        const appConfig = getMockedAppConfig(
                            // locationId: state.locationId,
                            // locationIds: state.locationIds,
                            state.role,
                            payload.data // locations configs {[locationID]: config}
                        );

                        return {
                            ...state,
                            appConfig
                        };
                    } catch (e) {
                        console.error(e);
                        return { ...initialState };
                    }
                }

                default:
                    return state;
            }
        }

        case SEND_REQUEST_FAIL: {
            if (request.type === REQUEST_TYPES.LOGIN) {
                sendEvent(...EVENT_ARGS().authorization.authFailure);
            } else if (request.type === REQUEST_TYPES.GET_CONFIG) {
                return { ...initialState };
            }
            return state;
        }

        case LOGOUT: {
            return { ...initialState };
        }
        case REHYDRATION_DONE: {
            return state;
        }

        default: {
            return state;
        }
    }
};
